import './CircularLoader.pcss';

export function CircularLoader (): JSX.Element {

  return (
    <div className="loader center">
      <span />
    </div>
  );
}
